<template>
  <div>
    <v-card outlined>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subtitle-1">{{ $t("labels.reconcileService") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout column="column">
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.assignedUser") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex
              class="font-weight-regular text-right"
              v-if="service.reconcile.assignedToUser"
              >{{ service.reconcile.assignedToUser.fullName }}</v-flex
            >
            <v-flex class="font-weight-regular text-right" v-else>Not Assigned</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.plan") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex
              class="font-weight-regular text-right"
              v-if="service.reconcile.Product.productDetail"
              >{{ service.reconcile.Product.productDetail }}</v-flex
            >
            <v-flex class="font-weight-regular text-right" v-else>Not Set</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.fee") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex class="font-weight-regular text-right">{{
              service.reconcile.softwareFee | currency
            }}</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.teamviewerid") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex class="font-weight-regular text-right">{{
              service.reconcile.teamViewerID
            }}</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.accessCode") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex class="font-weight-regular text-right">{{
              service.reconcile.accessCode
            }}</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.userName") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex class="font-weight-regular text-right">{{ service.reconcile.userName }}</v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout row="row" wrap>
            <v-flex>{{ $t("labels.password") }}</v-flex>
            <v-spacer> </v-spacer>
            <v-flex class="font-weight-regular text-right">{{ service.reconcile.password }}</v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import reconcileService from "../service.js";
import locationService from "../../Location/service.js";
// const Edit = () => import('./Edit')

export default {
  data() {
    return {
      createDialog: false,
      editDialog: false,
      isReconcile: false
    };
  },
  computed: {
    ...mapGetters("location", ["location", "service"])
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    openLink() {
      window.open(`${this.service.reconcile.folderLink}`, "_blank");
    },
    created() {
      this.createDialog = false;
    },
    updated() {
      this.editDialog = false;
    },
    close() {
      this.createDialog = false;
      this.editDialog = false;
    },
    // getByStoreID() {
    //   reconcileService.getByStoreID(this.location.storeID)
    //   .then(result => {
    //     this.reconcile = result.data
    //   })
    // },
    updateStore(data) {
      return locationService.updateStore(this.location.storeID, data).then(result => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "success",
            title: "Update Successfully"
          });
        this.setLocation(this.location.storeID);
      });
    }
    // async updateReconcile(val) {
    //   if (val.value) {
    //     if(this.reconcile) {
    //       this.isReconcile = val.value
    //       this.location.reconcile = val.value
    //       let data = {
    //         reconcile: val.value
    //       }
    //       this.updateStore(data)
    //     } else {
    //       this.createDialog = true
    //     }
    //   }else {
    //     const {value: text} = await this.$swal.fire({
    //     title: 'Reason',
    //     input: 'textarea',
    //     inputPlaceholder: 'Type your message here...',
    //     showCancelButton: true
    //     })
    //     if (text) {
    //       let data = {
    //         reconcileReason: text,
    //         reconcile: val.value
    //       }
    //       this.updateStore(data)
    //       this.reconcile = null
    //       this.showEdit = false
    //     } else {
    //       this.isReconcile = !this.isReconcile
    //     }
    //   }
    // },
  }
};
</script>

<style scoped></style>
